import Promise from 'promise-polyfill'

const Report = {
  namespaced: true,
  actions: {
    printSppdSummary: (context, payload) => {
      const vue = payload.vueinstance
      return new Promise((resolve, reject) => {
        vue.$backend.report.printSppdSummaryUsingGET({...payload.params})
          .then(res => { resolve(res) }).catch(err => reject(err))
      })
    },
    reset: (context, payload) => {}
  }
}

export default Report



// WEBPACK FOOTER //
// ./src/store/master/Report.js